export enum ButtonSizeEnum {
  regular = 'px-12 py-6',
  small = 'px-8 py-4',
}
